import "../img/jobs/job-video-01.png";
import "../img/jobs/job-video-02.png";
import "../img/icons/green-play-icon.svg";
import "../img/icons/play-button.svg";